namespace app.support {
  "use strict";

  export class NumeroUnicoCNJ {
    public filter(value: string): string {
      if (value.length < 20) {
        return '';
      }

      return `${value.slice(0, 7)}-${value.slice(7, 9)}.${value.slice(9, 13)}.${value.slice(13, 14)}.${value.slice(14, 16)}.${value.slice(16)}`;
    }

    public static factory() {
      return () => {
        'ngInject';
        return new NumeroUnicoCNJ().filter;
      }
    }
  }

  angular.module('app.support')
    .filter('numeroUnicoCNJ', NumeroUnicoCNJ.factory());
}